/**
 * 分销商结算
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2022, all rights reserved. Essa.cn
 */
import React from 'react';
import {Tabs, Spin, Space, Button, Badge, Select, message,Radio,Popover } from "antd";
import Lang from "@/components/Lang/Lang";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import EssaModal from "@components/EssaModal/EssaModal";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import DistributorAction from "../Distributor.action";
import dayjs from 'dayjs';
import Cookie from "@utils/cookie";
import "./Settlement.less";
import {isEmpty} from "@utils/utils";
// const { TabPane } = Tabs;
const Option = Select.Option;
const config = require("../../../../config/config");
const Locale = require("../../../utils/locale").default;
let locale = Locale.current();
class Settlement extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            searchFormOptionsOne:[
                {
                    name:'time',
                    cnTitle:'申请时间',
                    cnTitleId:'ShenQingShiJian',
                    cnPlaceholder:[Lang({id:'KaiShiShiJian',default:'开始时间'}),Lang({id:'JieShuShiJian',default:'结束时间'})],
                    cnPlaceholderId:['KaiShiShiJian','JieShuShiJian'],
                    searchRange:['startTime','endTime'],
                    type:'DateRangePicker',
                    width:300,
                    canSearch:true,
                },
                {
                    name:'keyword',
                    cnPlaceholder:'搜索流水号/分销商账号/姓名',
                    cnPlaceholderId:'SouSuoLiuShuiHaoFenXiaoShangZhangHaoXinMing ',
                    hiddenLabel:true,
                    type:'SearchInput'
                },
            ],
            searchFormOptionsNoLable:[
                {
                    name:'time',
                    cnTitle:'申请时间',
                    cnTitleId:'ShenQingShiJian',
                    cnPlaceholder:[Lang({id:'KaiShiShiJian',default:'开始时间'}),Lang({id:'JieShuShiJian',default:'结束时间'})],
                    cnPlaceholderId:['KaiShiShiJian','JieShuShiJian'],
                    searchRange:['startTime','endTime'],
                    type:'DateRangePicker',
                    width:300,
                    hiddenLabel:true,
                    canSearch:true,
                },
                {
                    name:'keyword',
                    cnPlaceholder:'搜索流水号/分销商账号/姓名',
                    cnPlaceholderId:'SouSuoLiuShuiHaoFenXiaoShangZhangHaoXinMing ',
                    hiddenLabel:true,
                    type:'SearchInput'
                },
            ],
            columns:[
                {
                    dataIndex: 'createTime',
                    cnTitle: '申请时间',
                    cnTitleId: 'ShenQingShiJian',
                    render:(text, record, index) => (<div>
                        <p>{record.createTime?dayjs(record.createTime).format("YYYY-MM-DD HH:mm:ss"):'-'}</p>
                        <p>{record.code}</p>
                    </div>),
                },
                {
                    dataIndex: 'fxUserName',
                    cnTitle: '分销商账号',
                    cnTitleId: 'FenXiaoShangZhangHao',
                    render: (oderStatus, record={}) => {
                        return(<div>
                            {record.isChange==1&&<Badge status="error" />}<span>{oderStatus}</span>
                        </div>)},
                },
                {
                    dataIndex: 'fxName',
                    cnTitle: '姓名',
                    cnTitleId: 'XingMing',
                },
                {
                    cnTitle: '待结算金额',
                    cnTitleId: 'DaiJieSuanJinE',
                    dataIndex: 'amounts',
                    type:'money',
                    showSymbol:'currencySymbol'
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<div><Space>
                        <Button className={"btn-hover"} onClick={()=>this.showApproved(record)}>{Lang({id: 'HeXiao',default:'核销'})}</Button>
                        <Button className={"btn-hover"} onClick={()=>this.showReturnSettlement(record)}>{Lang({id: 'TuiHui',default:'退回'})}</Button>
                    </Space></div>)
                    },
            ],
            columnsReviewed:[
                {
                    dataIndex: 'handleTime',
                    cnTitle:'结算时间',
                    cnTitleId:'JieSuanShiJian',
                    render:(handleTime, record, index) => (<div>
                        <p>{record.handleTime?dayjs(record.handleTime).format("YYYY-MM-DD HH:mm:ss"):'-'}</p>
                    </div>),
                },
                {
                    dataIndex: 'createTime',
                    cnTitle: '申请时间',
                    cnTitleId: 'ShenQingShiJian',
                    render: (createTime, record) => {
                        return(<div>
                            <p>{record.createTime?dayjs(record.createTime).format("YYYY-MM-DD HH:mm:ss"):'-'}</p>
                            <p>{record.code}</p>
                        </div>)},
                },
                {
                    dataIndex: 'fxUserName',
                    cnTitle: '分销商账号',
                    cnTitleId: 'FenXiaoShangZhangHao',
                    render: (oderStatus, record) => {
                        return(<div>
                            {record.isChange==1&&<Badge status="error" />}<span>{oderStatus}</span>
                        </div>)},
                },
                {
                    dataIndex: 'fxName',
                    cnTitle: '姓名',
                    cnTitleId: 'XingMing',
                },
                {
                    cnTitle: '已结算金额',
                    cnTitleId: 'DaiJieSuanJinE',
                    dataIndex: 'amounts',
                    type:'money',
                    showSymbol:'currencySymbol',
                },
                {
                    dataIndex: 'handlerName',
                    cnTitle: '操作人',
                    cnTitleId: 'CaoZuoRen',
                },
            ],
            columnsCancel:[
                {
                    dataIndex: 'handleTime',
                    cnTitle:'退回时间',
                    cnTitleId:'TuiHuiShiJian',
                    render:(handleTime, record, index) => (<div>
                        <p>{record.handleTime?dayjs(record.handleTime).format("YYYY-MM-DD HH:mm:ss"):'-'}
                            {record.handleRemark&&<Popover content={<div>
                                <p>{Lang({id:'TuiHuiYuanYin',default:'退回原因'})}</p>
                                <p style={{color: '#939aa3'}}>{record.handleRemark}</p>
                            </div>} >
                                <i className="iconfont icon-xinxix margin-left-4 color-grey"></i>
                            </Popover>}
                        </p>
                    </div>),
                },
                {
                    dataIndex: 'createTime',
                    cnTitle: '申请时间',
                    cnTitleId: 'ShenQingShiJian',
                    render: (createTime, record) => {
                        return(<div>
                            <p>{record.createTime?dayjs(record.createTime).format("YYYY-MM-DD HH:mm:ss"):'-'}</p>
                            <p>{record.code}</p>
                        </div>)},
                },
                {
                    dataIndex: 'fxUserName',
                    cnTitle: '分销商账号',
                    cnTitleId: 'FenXiaoShangZhangHao',
                    render: (oderStatus, record) => {
                        return(<div>
                            {record.isChange==1&&<Badge status="error" />}<span>{oderStatus}</span>
                        </div>)},
                },
                {
                    dataIndex: 'fxName',
                    cnTitle: '姓名',
                    cnTitleId: 'XingMing',
                },
                {
                    cnTitle: '已退回金额',
                    cnTitleId: 'YiTuiHuiJinE',
                    dataIndex: 'amounts',
                    type:'money',
                    showSymbol:'currencySymbol',
                },
                {
                    dataIndex: 'handlerName',
                    cnTitle: '操作人',
                    cnTitleId: 'CaoZuoRen',
                },
            ],
            auditStatus:'1',//默认 1:待结算 2:已结算 3.已退回
            twoTimeType:'2', // 时间查询类型 1:申请时间; 2:处理时间(结算时间,退回时间)
            threeTimeType:'2', // 时间查询类型 1:申请时间; 2:处理时间(结算时间,退回时间)
            total: 0,
            showApproved:false,//是否显示核销窗口，
            showReturnSettlement:false,// 是否显示退出窗口
            typesReturnSettlement:[],
            currRow:{},
        }
    }
    /**
     * 改变状态
     **/
    changeTab(activeKey){
        this.setState({
            auditStatus:activeKey
        },()=>{
            switch (activeKey) {
                case '3':
                   if(this.onRefChildCancleTab){
                       this.onRefChildCancleTab.handleFetch();
                   }
                    break
                case '2':
                    if(this.onRefTabChildTwo){
                        this.onRefTabChildTwo.handleFetch();
                    }
                    break
                case '1':
                    if(this.onRefTabChildOne){
                        this.onRefTabChildOne.handleFetch()
                    }
            }
        })
    }
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    onRefTabTwo = (ref) =>  this.onRefTabChildTwo = ref;
    onRefCancelTab = (ref) =>  this.onRefChildCancleTab = ref;
    /**
     * 核销
     * */
    showApproved(recode) {
        this.setState({
            showApproved: true,
            currRow: recode
        })
    }
    /**
     * 退回
     * */
    showReturnSettlement(recode){
        const { typesReturnSettlement } = this.state;
        // console.log('typesReturnSettlement',typesReturnSettlement)
       if(typesReturnSettlement.length>0){
           this.setState({
               showReturnSettlement: true,
               currRow: recode,
           })
       }else {
           const types = __getDictList('wallet_withdraw_item_handle_remark_code')||[];
           this.setState({
               showReturnSettlement: true,
               currRow: recode,
               typesReturnSettlement:types,
           })
       }
    }
    onChangeReason(e){
        this.setState({
            returnReason: e.target.value,
        })
    }
    /**
     * 处理 提现审核(2.0)
     * status	1:核销 -1:退回
     * handleRemarkCode  字典编码:wallet_withdraw_item_handle_remark_code
     * */
    handleApproved(currRow={},status='',handleRemarkCode=''){
        if(isEmpty(status)) return;
        let postData = {
            id:currRow.id,
            status:status
        }
        if(status=='-1'&&isEmpty(handleRemarkCode)){ //退出 时原因必填
            message.warning(Lang({id: "QingGouXuanTuiHuiJieSuanShenQingYuanYin",default: "请勾选退回结算申请原因"}))
            return false
        }
        if(!isEmpty(handleRemarkCode))postData['handleRemarkCode'] = handleRemarkCode;
        DistributorAction.updateApproved(postData).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err));
    }
    handleRes(res){
        this.loading(false);
        const {success,valid,} = res;
        if(success&&valid){
            message.success(Lang({id: 'CaoZuoChengGong', default: '操作成功'}))
            this.handleClose()
            setTimeout(()=>{
                this.onRefTabChildOne.handleFetch();
            },200)
        }else if(res.message)message.warning(res.message);
    }
    handleClose(){
        this.setState({
            showApproved: false,
            showReturnSettlement: false,
            currRow: {},
            returnReason:'',
        })
    }
    /**
     * 	时间查询类型
     * */
    onChangeTwoDateType(value=''){
        this.setState({
            twoTimeType:value,
        },()=> {
            this.onRefTabChildTwo.handleFetch();
        })
    }
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * */
    onChangeThreeDateType(value=''){
        this.setState({
            threeTimeType:value,
        },()=> {
            this.onRefChildCancleTab.handleFetch();
        })
    }

    /**
     * 导出
     */
    handleExport = () => {
        //  /data/bpms/jreport/mg/fexiaoCommission/withdrawItem/print
        let {userId} = Cookie.getJSON("fmg.extra") || {};
        let template =
            locale === "ru"
                ? "MgFenxiaoCommissionWithdrawItemReport_ru"
                : "MgFenxiaoCommissionWithdrawItemReport_zh";
        let href =
            config.servers[config.environment].exportApi +
            `/data/bpms/jreport/mg/fexiaoCommission/withdrawItem/print?template=${template}&userId=${userId}`;
        //地址拼接，如果没有数据也要拼接
        href += `&langCode=${locale}`; ;
        href += "&isCheck=0";
        window.open(href);
    };

    componentDidMount() {}

    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const { loading,searchFormOptionsOne,searchFormOptionsNoLable,columns,auditStatus,columnsReviewed, columnsCancel,twoTimeType,threeTimeType,showApproved,currRow,showReturnSettlement,typesReturnSettlement,returnReason} = this.state;
        const currPageName = Lang({id: "FenXiaoShangJieSuan",default: "分销商结算"});
        const setRight =(<div className={'textRight'}>
            {/* <Button onClick={() => {this.handleExport()}} icon={<span className="ri-logout-box-r-line font_14"></span>}>
                <span className="font_12">{Lang({id: "DaoChuShuJu"})}</span>
            </Button> */}

            <AuthBtn  icon={'ri-logout-box-r-line'} onClick={() => {this.handleExport()}}  auth={'Distributor-Settlement-Export-Button'}  className="export-style"  title={Lang({id: 'DaoChuShuJu', default: '导出数据'})}>
                                    </AuthBtn>


        </div>);
        return (<Spin tip='loading' spinning={loading}>
                <div className="distributor-settlement-warp ">
                    <div className={"top-title"}>{currPageName}</div>
                    <Tabs defaultActiveKey={auditStatus}
                          items={[
                              {
                                  key: '1',
                                  label: Lang({id: 'DaiJieSuan', default: '待结算'}),
                                  children:( <div className={'content'}>
                                      <AutoFetchTable columns={columns}
                                                      onRef={this.onRefTabOne}
                                                      topSearchRightCont={setRight}
                                                      searchFormOptions={searchFormOptionsOne}
                                                      precondition={{ //前置条件
                                                          status:0, // 	列表类型 0:待结算 1:已结算 -1:已退回
                                                          timeType: 1, // 时间查询类型 1:申请时间; 2:处理时间(结算时间,退回时间)
                                                      }}
                                                      flagShowReset={false}
                                                      flagShowSearchBtn={false}
                                                      fetchApi={'/service/mg/distributor/withdraw-item-list'}>
                                      </AutoFetchTable>
                                  </div>)
                              }, {
                                  key: '2',
                                  label:Lang({id: 'YiJieSuan2', default: '已结算'}),
                                  children:(<div className={'content'}>
                                      <AutoFetchTable columns={columnsReviewed}
                                                      onRef={this.onRefTabTwo}
                                                      searchFormOptions={searchFormOptionsNoLable}
                                                      topSearchFarLeft={<Select value={twoTimeType} onChange={(value)=>this.onChangeTwoDateType(value)} style={{width:'150px',marginRight:'10px',}} >
                                                          <Option value="1">{Lang({id: 'ShenQingShiJian', default: '申请时间'})}</Option>
                                                          <Option value="2">{Lang({id: 'JieSuanShiJian', default: '结算时间'})}</Option>
                                                      </Select>}
                                                      precondition={{
                                                          status:1, // 	列表类型 0:待结算 1:已结算 -1:已退回
                                                          timeType: twoTimeType, //前置 时间类型
                                                      }}
                                                      flagShowReset={false}
                                                      flagShowSearchBtn={false}
                                                      fetchApi={'/service/mg/distributor/withdraw-item-list'}  />
                                  </div>)
                              },{
                                  key:"3",
                                  label:Lang({id: 'YiTuiHui', default: '已退回'}),
                                  children:(<div className={'content'}>
                                      <AutoFetchTable columns={columnsCancel}
                                                      onRef={this.onRefCancelTab}
                                                      searchFormOptions={searchFormOptionsNoLable}
                                                      topSearchFarLeft={<Select value={threeTimeType} onChange={(value)=>this.onChangeThreeDateType(value)} style={{width:'150px',marginRight:'10px',}} >
                                                          <Option value="1">{Lang({id: 'ShenQingShiJian', default: '申请时间'})}</Option>
                                                          <Option value="2">{Lang({id: 'TuiHuiShiJian', default: '退回时间'})}</Option>
                                                      </Select>}
                                                      precondition={{
                                                          status: -1, // 	列表类型 0:待结算 1:已结算 -1:已退回
                                                          timeType: threeTimeType
                                                      }}
                                                      flagShowReset={false}
                                                      flagShowSearchBtn={false}
                                                      fetchApi={'/service/mg/distributor/withdraw-item-list'}  />
                                  </div>)
                              }
                          ]}
                          onChange={(activeKey)=>this.changeTab(activeKey)}>
                    </Tabs>
                    {showReturnSettlement&&<EssaModal title={Lang({id:'TuiHuiJieSuanShenQing',default:'退回结算申请'})}
                                                      open={showReturnSettlement}
                                              width={500}
                                              loading={loading}
                                              onOk={()=>this.handleApproved(currRow,-1,returnReason)}
                                              onCancel={()=>this.handleClose()}>
                        <div className={"wrap-return-reason"}>
                            <div className={"title"}>{Lang({id: "QingGouXuanTuiHuiJieSuanShenQingYuanYin",default: "请勾选退回结算申请原因"})}</div>
                            <Radio.Group defaultValue={returnReason} onChange={(e)=>this.onChangeReason(e)}>
                                {typesReturnSettlement.map(item=><p><Radio key={item.code} value={item.code}>{item.name}</Radio></p>)}
                            </Radio.Group>
                        </div>
                    </EssaModal>}
                    {showApproved&&<EssaModal title={Lang({id:'TiShi',default:'提示'})}
                                              open={showApproved}
                                                   width={500}
                                                   loading={loading}
                                                   onOk={()=>this.handleApproved(currRow,1)}
                                                   onCancel={()=>this.handleClose()}>
                        <p>{Lang({id: "QueRenHeXiaoGaiBiDaiJieSuanMa",default: "确认核销该笔待结算吗"})}</p>
                    </EssaModal>}
                </div>
            </Spin>

        )
    }
}

export default Settlement;
